import { useEventsPublisher } from "event-bus";
import { SetupArea, SetupAreaVersionStatus } from './setupAreas';
import { useBackendApi } from "./backendApi";
import { MARKETS_UPDATED } from "./marketsAdminService";


export interface CreateSetupAreaVersionRequest {
  version: string;
  description?: string;
}

export interface UpdateSetupAreaVersionRequest {
  version: string,
  status: SetupAreaVersionStatus,
  description?: string;
}

export function useSetupAreaVersionAdminService() {
  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const createVersion = async (
    areaId: number,
    request: CreateSetupAreaVersionRequest
  ) => {
    const result = await backendApi.post(`/manager/setupareas/${areaId}/versions`, request) as SetupArea;

    eventsPublisher.publish(MARKETS_UPDATED, {});

    return result;
  };

  const updateVersion = async (
    areaId: number,
    version: string,
    request: UpdateSetupAreaVersionRequest
  ) => {
    const result = await backendApi.put(`/manager/setupareas/${areaId}/versions/${version}`, request) as SetupArea;

    eventsPublisher.publish(MARKETS_UPDATED, {});

    return result;
  }

  const copyVersion = async (
    areaId: number,
    sourceVersion: string,
    request: CreateSetupAreaVersionRequest,
  ) => {
    const result = await backendApi.post(`/manager/setupareas/${areaId}/versions/${sourceVersion}/copy`, request) as SetupArea;

    eventsPublisher.publish(MARKETS_UPDATED, {});

    return result;
  }

  const deleteVersion = async (
    areaId: number,
    version: string
  ) => {
    await backendApi.delete(`/manager/setupareas/${areaId}/versions/${version}`);

    eventsPublisher.publish(MARKETS_UPDATED, {});
  }

  const getValidationSchema = async () => {
    return {
      version: {
        required: 'Version is required',
        pattern: {
          value: /^ [0-9]+\.[0-9]+$/,
          message: 'Version must be in the format X.Y (e.g., 1.0)'
        }
      }
    };
  };

  return {
    createVersion,
    updateVersion,
    deleteVersion,
    copyVersion,
    getValidationSchema
  };
}
